import { NotificationState } from '@/interfaces/states/notification-state.interface';

export default {
  error: (state: NotificationState): string | null => state.error,

  success: (state: NotificationState): string | null => state.success,
};
